export enum CameraMode {
  API = 'api',
  UPLOAD = 'upload',
}

export enum AutoConnectCameraStatus {
  CONNECTING = 'connecting',
  CONNECTED = 'connected',
  FAILED = 'failed',
}
